import { render, staticRenderFns } from "./CompanyScope.vue?vue&type=template&id=3ac7cc5f&scoped=true&"
import script from "./CompanyScope.vue?vue&type=script&lang=js&"
export * from "./CompanyScope.vue?vue&type=script&lang=js&"
import style0 from "./CompanyScope.vue?vue&type=style&index=0&id=3ac7cc5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac7cc5f",
  null
  
)

export default component.exports